<template>
  <div>
    <a @click="$emit('clicked')" class="default">
      <slot v-if="!loading" />
      <template v-else>
        Loading ...
      </template>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>
